module.exports = __webpack_public_path__ + "img/warning_system.c09ae621.jpeg";